/**
 * Vuex actions for the "popup" module.
 *
 * Toggle modal visibility (locking/unlocking body scroll as needed) and
 * store the payload data shown inside each modal. Closing an auth-related
 * modal (main, org, about-us, reply) also schedules a debounced `getMe`
 * refresh so the current user's state stays in sync after the modal closes.
 */
import { toggleScroll } from '@/helpers/scrollControlHelper.js';

// Simple debouncer to throttle auth refresh after modal close
let refreshTimer = null;
function scheduleAuthRefresh(dispatch) {
  try { if (refreshTimer) clearTimeout(refreshTimer); } catch {}
  refreshTimer = setTimeout(() => {
    try { dispatch('getMe'); } catch {}
  }, 400); // small delay to ensure UI is stable after close
}

export default {
  /** Toggle body scroll and the main modal's visibility; schedule an auth refresh on close. */
  showModal({ commit, dispatch }, value) {
    toggleScroll(value);
    commit('setShowModal', value);
    if (value === false) scheduleAuthRefresh(dispatch);
  },
  /** Toggle body scroll and the org modal's visibility; schedule an auth refresh on close. */
  showOrgModal({ commit, dispatch }, value) {
    toggleScroll(value);
    commit('setOrgShowModal', value);
    if (value === false) scheduleAuthRefresh(dispatch);
  },
  /** Toggle the draft modal's visibility. */
  showModalDraft({ commit }, value) {
    commit('setShowModalDraft', value);
  },
  /** Toggle body scroll and the "about us" modal's visibility; schedule an auth refresh on close. */
  showModalAboutUs({ commit, dispatch }, value) {
    toggleScroll(value);
    commit('setShowModalAboutUs', value);
    if (value === false) scheduleAuthRefresh(dispatch);
  },
  /** Toggle body scroll and the reply modal's visibility; schedule an auth refresh on close. */
  showModalReply({ commit, dispatch }, value) {
    toggleScroll(value);
    commit('setShowModalReply', value);
    if (value === false) scheduleAuthRefresh(dispatch);
  },
  /** Store the modal payload (routed to `modalData` or `modalOrgData` by the mutation). */
  addModalDataToState({ commit }, payload) {
    commit('setModalData', payload);
  },
  /** Store the post data being replied to. */
  setReplyData({ commit }, data) {
    commit('setReplyPostData', data);
  },
  /** Store the post data being quoted. */
  setQuoteData({ commit }, data) {
    commit('setQuotePostData', data);
  },
};
